export const EnumTipoCaracteristica = {
  Data: 'Data',
  Tabela: 'Tabela',
  Decimal: 'Decimal',
  Inteiro: 'Inteiro',
  Texto: 'Texto',
};
